export enum MenuHomeEnum {
    NA = 0,
    Dashboard = 1000,
    Application = 1,
    Training = 2,
    Activation = 3,
    SkillsAssessments = 4,
    ExcistingDriversActivation = 5,
    ExcistingDriversVehicles = 6,
    Users = 7,
    Transactions = 8,
    Drivers = 9,
    Accounting = 10,
    Settings = 11,
    DriverTraining = 12,
    Disciplinary = 13,
    DriverCenters = 14,
    Calendar = 15,
    MartOnboarding = 16,
    FoodOnboarding = 17,
    TNVSApplication = 18,
    Classroom = 19,
    DocumentRenewal = 20,
    SystemStatus = 21,
    DisciplinaryNewCases = 22,
    DisciplinaryInProcess = 23,
    DisciplinaryArchived = 24,
    OperatorsVehicles = 25,
    OperatorsTODAs = 26,
    DraftDrivers = 27,
    SuspendedUser = 28,
    BlacklistUsers = 29,
    RegistrationResubmissions = 30,
    RegistrationRejected = 31,
    ActiveDrivers = 32,
    CebuanaPayout= 33,
    OnlineTransfer = 34,
    RegistrationApplication = 35,
    CompaignDrivers = 36,
    CompaignXpress50Drivers = 37,
    AuditVerification = 38,
    ApplicationAudit = 39,
    AuditHistory = 40,
    AuditReports = 41,
    CampaignUsers = 42,
    CampaignUsers_Users = 43,
    CampaignUsers_Transactions = 44,
    Xpress50Riders4W = 45,
    PriorityOrderDrivers = 46,
    OperatorVehicles = 47,
    OperatorsPassenger2W = 48,
    OperatorsPassenger4W = 49,
    PartnerDashboard = 49,
    PartnerEmployees = 50,
    PartnerCatalogue = 51,
    PartnerInventory = 52,
    PartnerFinance = 53,
    PartnerAppConfig = 54,
    AllOrder = 55,
    Feedback = 56,
    Stores = 57,
    Groups = 58,
    Marketing = 59,
    BusinessInfo = 60,
    LegalDocuments = 61,
    PayoutAccount = 62,
    AuthorizedRepresentative = 63,
    PartnershipTerms = 64,
    StoreEmployees = 65,
    AllProducts = 66,
    Categories = 67,
    Bundles = 68,
    Payouts = 69,
    NextPayout = 70,
    Invoices = 71,
    StoreIdentity = 72,
    RecommendedProducts = 73,
    CategoryOrder = 74,
    AllPromotions = 75,
    Performance = 76,
    RecommendeedPromo = 77,
    Campaigns = 78,
    CreateCampaign = 79,
    Overview = 80,
    Operations = 81,
    Products = 82,
    Customers = 83,
    Reviews = 84,
    VehicleUpgrades = 1,
    Xpress2WEV = 85,
    Xpress4WEV = 86,
    PartnerDashboardSwitch = 87,
    AllanGroup = 88,
    LoopPassCampaign = 89,
	NiloGroup = 90,
	Xpress4WEVBataan = 91,
	Taxi = 92,
	TaxiVehicles = 93,
	FinanceReports = 94,
	ExperienceDashboard = 95,
	ExperienceOperatorReg = 96,
	ExperienceListingReview = 97,
	ExperienceBookingOversight = 98,
	ExperienceCompliance = 99,
	ExperienceNotification = 100,
	ExperienceSandbox = 101,
	TourOperators = 102,
	ConneX = 103,
	ConneXVehicles = 104,
    RegistrationV2 = 105,
    Gph = 106,
}
